const TransportOrderList = () => import('Views/transportOrder/transportOrder-list');
const TransportOrderAddEdit = () => import('Views/transportOrder/transportOrder-addEdit');
const TransportOrderDetail = () => import('Views/transportOrder/transportOrder-detail');
const TransportOrderStatus = () => import('Views/transportOrder/transportOrder-status');
const TransportOrderMonitor = () => import('Views/transportOrder/transportOrder-monitor');

export default[
  { path: '/transportOrder-list', component: TransportOrderList },
  { path: '/transportOrder-add', component: TransportOrderAddEdit },
  { path: '/transportOrder-edit/:id', component: TransportOrderAddEdit },
  { path: '/transportOrder-detail/:id', component: TransportOrderDetail },
  { path: '/transportOrder-status/:id', component: TransportOrderStatus },
  { path: '/transportOrder-monitor/:id', component: TransportOrderMonitor },
];



// WEBPACK FOOTER //
// ./src/router/transportOrder.js